// Helper function to determine API URL based on current location
function getApiUrl(): string {
  // Check if we're in a browser environment
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    const port = window.location.port;

    // Check if backend URL is provided via meta tag (optional advanced configuration)
    const metaBackendUrl = document.querySelector('meta[name="backend-url"]');
    if (metaBackendUrl) {
      return metaBackendUrl.getAttribute('content') + '/api';
    }

    // If on standard HTTP/HTTPS ports (no port in URL, or 80/443), use /api path
    // This handles both production and dev --ssl mode where nginx proxies /api
    if (!port || port === '80' || port === '443') {
      return `${protocol}//${hostname}/api`;
    }

    // Map frontend dev ports to backend ports
    const portMapping: { [key: string]: string } = {
      '4200': '3000', // Default Angular dev server to backend
    };

    const backendPort = portMapping[port] || '3000';
    return `${protocol}//${hostname}:${backendPort}/api`;
  }

  // Fallback for non-browser environments (e.g., during build)
  return 'http://127.0.0.1:3000/api';
}

export const environment = {
  production: false,
  apiUrl: getApiUrl(),
  apiBaseUrl: getApiUrl(),
  spotify: {
    redirectUri: getApiUrl().replace('/api', '/api/auth/callback'),
    scopes: [
      'playlist-read-private',
      'playlist-modify-public',
      'playlist-modify-private',
      'streaming',
      'user-read-playback-state',
      'user-modify-playback-state',
      'user-library-read',
      'user-library-modify',
      'user-read-currently-playing',
      'user-read-recently-played'
    ]
  }
};